package com.karawek.core.platform

class WebPlatformContext : PlatformContext
